// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__C0LuR","input":"styles_input__mf00o","errorMsg":"styles_errorMsg__yuxiD","error":"styles_error__Uq+V-"};